import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestGET, RestRequestPOST} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";
import HeaderService from "./HeaderService";
import validateSection from "./helpers/validateSection";
import {DemandValidation} from "constants/DemandValidation";
import isResponseValid from "../libs/isResponseValid";
import Tr from "../translations/Translations";

const FINISH_DEMAND_RESOURCE_ID = 'finishDemand';

const getFinishDemand = async (demandId) => {
    const resp = await RestRequestGET(Endpoints.FINISH_DEMAND(demandId));
    reduxStore.dispatch(setResource(FINISH_DEMAND_RESOURCE_ID, resp))
}

const backToOfferEvaluation = async (demandId) => {
    clearFinishDemand();
    return await RestRequestPOST(Endpoints.FINISH_DEMAND_BACK_TO_OFFER_EVALUATION(demandId));
}

const backToResultNotice = async (demandId) => {
    clearFinishDemand();
    const resp = await RestRequestPOST(Endpoints.FINISH_DEMAND_BACK_TO_RESULT_NOTICE(demandId));
    reduxStore.dispatch(setResource(FINISH_DEMAND_RESOURCE_ID, resp));
    await validateSection(DemandValidation.FINISH_DEMAND, demandId, false);
    await validateSection(DemandValidation.RESULT_NOTICE, demandId, false);
}

const withdrawalNoticeDate = async (demandId, values) => {
    const data = {
        ...values,
        unpublishDate: values.unpublishDate ? values.unpublishDate.format() : null
    }
    return await RestRequestPOST(Endpoints.FINISH_DEMAND_WITHDRAWAL_NOTICE_DATE(demandId), data);
}

const cancelDemand = async (demandId) => {
    clearFinishDemand();
    const resp = await RestRequestPOST(Endpoints.FINISH_DEMAND_CANCEL(demandId));
    reduxStore.dispatch(setResource(FINISH_DEMAND_RESOURCE_ID, resp));
    await validateSection(DemandValidation.FINISH_DEMAND, demandId, false);
    await validateSection(DemandValidation.ARCHIVING, demandId, false);
    await validateSection(DemandValidation.DEMAND_PLAN_REALIZATION, demandId, false);
    await HeaderService.get(demandId)
}

const finishDemand = async (demandId) => {
    clearFinishDemand();
    const resp = await RestRequestPOST(Endpoints.FINISH_DEMAND_FINISH(demandId));
    reduxStore.dispatch(setResource(FINISH_DEMAND_RESOURCE_ID, resp))
    await validateSection(DemandValidation.FINISH_DEMAND, demandId, false);
    await validateSection(DemandValidation.ARCHIVING, demandId, false);
    await validateSection(DemandValidation.DEMAND_PLAN_REALIZATION, demandId, false);
    await HeaderService.get(demandId)
}

const validate = async (demandId) => {
    return await RestRequestGET(Endpoints.FINISH_DEMAND_VALIDATE(demandId));
}

const deleteFromSharePoint = async (demandId) => {
    try {
        const resp = await RestRequestPOST(Endpoints.SHAREPOINT_DELETE(demandId));
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return true;
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    return false;
}

const clearFinishDemand = () => {
    reduxStore.dispatch(clearResource(FINISH_DEMAND_RESOURCE_ID));
}

export default {
    getFinishDemand,
    backToOfferEvaluation,
    backToResultNotice,
    cancelDemand,
    finishDemand,
    validate,
    deleteFromSharePoint,
    withdrawalNoticeDate,
    clearFinishDemand,
    FINISH_DEMAND_RESOURCE_ID
}